import React  from 'react'
import { IoCloseOutline } from "react-icons/io5";
import CourseReqTable from '../table/CourseReqTable';
import { motion } from 'framer-motion'



const CoursesReqModal = ({setModal, data}) => {

  return (
    <motion.div 
     initial={{ scale: 0.5, opacity: 0 }}
     animate={{ scale: 1, opacity: [0.1, 0.1, 0.1, 0.3, 0.5, 0.7, 1] }}
     transition={{ duration: 0.7, ease: "easeIn" }}
     exit={{ opacity: 0, transition: { duration: 1.5, ease: "easeIn" } }}
     className='relative w-full mb-20 max-h-[95vh] z-50 bg-white pt-5 pb-5 shadow-md rounded-xl md:pt-6 lg:pb-7 lg:mb-32 xl:pb-8 xl:mb-44 max-w-screen-lg mx-auto'>

       <div className='flex items-start justify-between w-full px-3 md:px-5 md:items-center lg:px-7'>
          <p className='text-[11px] text-[#808080] font-semibold w-[75%] md:text-[12px] lg:text-sm xl:text-base'>
              {data.title}
          </p>
          <IoCloseOutline onClick={()=>setModal(false)} className='text-xl lg:text-2xl xl:text-3xl' />
       </div>

       <div className='w-full mt-2.5 bg-[#DDE1E6] border-[1px] border-dashed lg:mt-3.5'></div>
       
       <div className='px-3 mb-20 w-full md:px-5 lg:px-7'>
            {/*TABLE*/}
            <div className='flex items-start justify-center w-full overflow-y-auto'>
                <CourseReqTable data={data} />
            </div>

            {/* CLOSE BUTTON */}
            <div className='flex items-center justify-end absolute bottom-6 right-3 w-full mt-8 px-3 md:px-5 lg:px-7 lg:mt-9 xl:mt-10'>
                  <div onClick={()=>setModal(false)}
                  className='flex items-center justify-center w-[75px] h-7 rounded-md bg-[#25A249] text-white cursor-pointer md:w-[90px] md:h-8 xl:h-10 xl:w-28 xl:rounded-lg'>
                      <p className='text-[11px] font-normal md:text-xs xl:text-base'>Close</p>
                      <IoCloseOutline  className='text-base ml-[6px] md:text-lg md:ml-2 xl:text-2xl' />
                  </div>
            </div>
        </div>

    </motion.div>
  )
}


export default CoursesReqModal
